angular
	.module('AutoPrequal')
	.controller('maintenanceCtrl', maintenanceCtrl);

maintenanceCtrl.$inject = ['$scope', '$rootScope', 'DataFactory'];

function maintenanceCtrl($scope, $rootScope, DataFactory) {
	$rootScope.currentStep = 'error';
	$rootScope.progressCurrent = 0;
	$rootScope.progressMobCurrent = 0;
	$scope.content = DataFactory.appData.content.maintenance;

	if (mtnc_on == "false") {
		$rootScope.restart();
	}
}